<style lang="scss" scoped>
.v-common-com-lottery {
  .list {
    position: relative;
    background: transparent;
    height: 100%;
    // width: 100%;
    // padding-bottom: 100%;
  }
  .item {
    width: 110px;
    height: 110px;
    position: absolute;
    background: #ffffff;
    border-radius:10px;
    overflow: hidden;
    &.item0 {
      left: 16px;
      top: 16px;
    }
    &.item1 {
      left: 142px;
      top: 16px;
    }
    &.item2 {
      left: 268px;
      top: 16px;
    }
    &.item3 {
      left: 268px;
      top: 142px;
    }
    &.item4 {
      left: 268px;
      top: 268px;
    }
    &.item5 {
      left: 142px;
      top: 268px;
    }
    &.item6 {
      left: 16px;
      top: 268px;
    }
    &.item7 {
      left: 16px;
      top: 142px;
    }
    .icon {
      // position: absolute;
      height: 100%;
      width: 100%;
      // z-index: 1;
    }
    .info {
      position: absolute;
      left: 0;
      bottom: 0;
      background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, .5));
      height: .48rem;
      width: 100%;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      width: 110px;
      height: 110px;
      border-radius:8px;
      background: rgba(0, 0, 0, .4);
      opacity: 0;
    }
    &.active>.mask{
      opacity: 1;
    }
  }
  .btn {
    width: 110px;
    height: 110px;
    background-color: #fff;
    background: url('./../assets/img/choujianganniu.svg') no-repeat;
    background-size: cover;
    position: absolute;
    left: 142px;
    top: 142px;
    border-radius:10px;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:active{
      opacity: 0.9;
    }
    .tips {
      // margin-top: 22px;
      width: 100%;
      text-align: center;
      display: block;
      font-size:28px;
      font-family:PingFangSC-Semibold;
      font-weight:600;
      color:rgba(99,51,40,1);
      line-height:40px;
      letter-spacing:2px;
    }
    .count {
      margin-top: 22px;
      width: 100%;
      text-align: center;
      display: block;
      font-size:15px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(99,51,40,1);
      line-height:21px;
      letter-spacing:1px;
      margin-top: 2px;
    }
  }
}
</style>

<template>
  <div class="v-common-com-lottery">
    <ul v-if="lotteryList.length === 0 ? false : true" class="list">
      <li class="item" :class="['item' + index, {'active': item.active}]" :key="index" v-for="(item, index) in lotteryList">
        <img class="icon" :src="item.pic" />
        <span class="mask"></span>
      </li>
      <li class="btn" @click="move">
        <span class="tips">抽奖</span>
        <span class="count" v-show="luckyTimes && isLive && isLogin">剩余{{luckyTimes}}次</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 奖单
      lotteryList: [],
      // 上次停留位置 index
      lastIndex: 0,
      // 服务器返回停留位置 index
      stopIndex: 0,
      // 正常转动动画
      timer1: null,
      // 进入低速转动动画
      timer2: null,
      // 低速转动动画
      timer3: null,
      // 正在执行动画
      isMoving: false,
      // 转动次数 最小28次（三圈半） 防止转动时间过短
      times: 0,
      // 接口成功返回停止stopIndex 标识
      ajaxEnd: false,
      // 进入低速转动动画 标识
      timerEnd: false,
      // 用户抽奖次数（实际应该是后台返回的次数）
      luckyTimes: 0,
      isShared: 0,
    };
  },
  watch: {
    times(val) {
      // 如果计数过程中，ajax未成功
      if (!this.ajaxEnd) {
        return false;
      }
      if (val >= 18) {
        this.timerEnd = true;
      }
    },
  },
  computed: {
    isLive() {
      return localStorage.getItem('isLive') === 'true';
    },
    isLogin() {
      return localStorage.getItem('isLogin') === 'true';
    }
  },
  methods: {
    getStopIndex() { // 获取服务器返回的index
      // 在这之前要先判断是否已经登陆并且登录没有过期
      this.$http.userLotteryCount({actCode: this.$str('actCode')},{headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}}).then((res) => {
        if(res.code !== 0){
          this.$toast({
            message: res.info,
            duration: 2000,
          })
          localStorage.clear();
          this.luckyTimes = 0;
          this.$bus.emit('resetLogin');
        } else {
          this.luckyTimes = res.data.leftLotteryCount || 0;
          this.isShared = res.data.isShared;
          this.$http.dayLottery({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_luckydraw_luckydraw_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}}).then((data) => {
            if(data.code !== 0){
              clearTimeout(this.timerFour);
              this.timerFour = setTimeout(() => {
                this.$toast({
                  message: data.info,
                  duration: 2000,
                })
              }, 500);
              this.lastIndex = 0;
              this.lotteryList.map((e) => {
                e.active = false;
              });
              this.isMoving = false;
              clearInterval(this.timer1);
              clearInterval(this.timer2);
              clearInterval(this.timer3);
            } else {
              this.stopIndex = parseInt(data.data.prize.level) - 1;
              this.ajaxEnd = true;
              this.prize = data.data.prize;
            }
          })
        }
      });
    },
    move() { // 点击开始抽奖按钮
      // this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_luckydraw_luckydraw_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}});
      this.$http.userLotteryCount({actCode: this.$str('actCode')},{headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}}).then((res) => {
        if(res.code === 10005){
          if(localStorage.getItem('isLogin') === 'true'){
            this.$toast({
              message: '登录已失效，请重新登录!',
              duration: 1500,
            });
          }
          localStorage.clear();
          this.$bus.emit('resetLogin');
          this.luckyTimes = 0;
          this.$bus.emit('showLoginBox');
          return false;
        }
        if(res.code !== 0 && localStorage.getItem('isLogin') === 'true'){
          this.$toast({
            message: res.info,
            duration: 2000,
          })
          localStorage.clear();
          this.luckyTimes = 0;
          this.$bus.emit('resetLogin');
        } else {
          this.luckyTimes = res.data.leftLotteryCount || 0;
          this.isShared = res.data.isShared;
        }
      }).then(() => {
        this.$http.actStatus({actCode: this.$str('actCode')}).then((res) => {
          if(res.data.activityStatus === 'live'){
            localStorage.setItem('isLive', true);
            localStorage.setItem('isWait', false);
            localStorage.setItem('isEnd', false);
          } else if(res.data.activityStatus === 'wait') {
            localStorage.setItem('isWait', true);
            localStorage.setItem('isLive', false);
            localStorage.setItem('isEnd', false);
          } else if(res.data.activityStatus === 'end') {
            localStorage.setItem('isEnd', true);
            localStorage.setItem('isLive', false);
            localStorage.setItem('isWait', false);
          }
        }).then(() => {
          if(localStorage.getItem('isLogin') !== 'true'){
            /* this.$toast({
              message: '请您先登录',
              duration: 2000,
            }) */
            this.$bus.emit('showLoginBox');
            return false;
          }
          if(localStorage.getItem('isWait') === 'true'){
            clearTimeout(this.timerOne);
            this.timerOne = setTimeout(() => {
              this.$toast({
                message: '活动还未开始',
                duration: 2000,
              })
            }, 500)
            return false;
          }
          if(localStorage.getItem('isEnd') === 'true'){
            clearTimeout(this.timerTwo);
            this.timerTwo = setTimeout(() => {
              this.$toast({
                message: '活动已经结束',
                duration: 2000,
              })
            }, 500)
            return false;
          }
          if(!this.luckyTimes && this.isShared){
            clearTimeout(this.timerThree);
            this.timerThree = setTimeout(() => {
              this.$toast({
                message: '今日抽奖机会已用完，请明天再来!',
                duration: 2000,
              })
            }, 500)
            return false;
          }
          if(!this.luckyTimes && !this.isShared) {
            clearTimeout(this.timerFour);
            this.timerFour = setTimeout(() => {
              this.$toast({
                message: '分享可获得1次抽奖机会！',
                duration: 2000,
              })
            }, 500)  
            return false;
          }
          if(this.isMoving) {
            return false;
          }
          this.isMoving = true;
          this.ajaxEnd = false;
          this.timerEnd = false;
          this.times = 0;
              // console.log('上次停止位置: ', this.lastIndex);
          let i = this.lastIndex;
          // 执行ajax请求数据
          this.getStopIndex();
          // 执行动画
          this.timer1 = setInterval(() => {
            this.times++;
            i++;
            if (i === 8) {
              i = 0;
            }
            this.lotteryList.map((e) => {
              e.active = false;
            });
            this.$set(this.lotteryList[i], 'active', true);
              // 当获取到服务器数据 index  并且高速动画转了至少两圈半
            if (this.timerEnd && this.ajaxEnd) {
              // console.log('服务器返回的停止位置: ', this.stopIndex);
              clearInterval(this.timer1);
              this.enter(i, this.stopIndex);
            }
          }, 100);
        })
      })
    },
    enter(cur, stop) { // 计算需要停止的index   高速到停止前的缓冲动画
      console.log(cur, stop);
      let count = stop - cur;
      if (count <= 4) {
        count = (count > -4 ? count + 8 : count + 16);
      }
      let i = cur;
      this.timer2 = setInterval(() => {
        count--;
        i++;
        if (i === 8) {
          i = 0;
        }
        this.lotteryList.map((e) => {
          e.active = false;
        });
        this.$set(this.lotteryList[i], 'active', true);
        if (count === 4) {
          clearInterval(this.timer2);
          this.stop(i, stop);
        }
      }, 200);
    },
    stop(cur, stop) { // 停止前的动画
      let count = 0;
      let i = cur;
      this.timer3 = setInterval(() => {
        count++;
        i++;
        if (i === 8) {
          i = 0;
        }
        this.lotteryList.map((e) => {
          e.active = false;
        });
        this.$set(this.lotteryList[i], 'active', true);
        if (count === 4) {
          clearInterval(this.timer3);
          this.isMoving = false;
          this.lastIndex = this.stopIndex;
          this.luckyTimes--;
          setTimeout(() => {
            if(this.prize.type === 'wequan'){
              this.$bus.emit('ShowLotteryWindowThree', this.prize);
            } else if(this.prize.type === 'redeem') {
              this.$bus.emit('ShowLotteryWindowTwo', this.prize);
            } else if(this.prize.type === 'object') {
              this.$bus.emit('ShowLotteryWindowOne', this.prize);
            }
            this.lastIndex = 0;
            this.lotteryList.map((e) => {
              e.active = false;
            });
          }, 300);
        }
      }, 300);
    },
  },
  mounted () {
    this.$bus.on('resetluckyTimes', () => {
      this.luckyTimes = 0;
    });
    //增加抽奖次数
    this.$bus.on('addPrizeChance', () => {
      this.luckyTimes += 1;
    });
    this.$http.lotteryList({actCode: this.$str('actCode')}).then((res) => {
      this.lotteryList = res.data.map((item) => {
        return {
          active: false,
          level: item.level,
          name: item.name,
          pic: item.pic,
          subname: item.subname,
          type: item.type,
          value: item.value,
        }
      })
    });
    this.$http.userLotteryCount({actCode: this.$str('actCode')},{headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}}).then((res) => {
      if(res.code !== 0 && localStorage.getItem('isLogin') === 'true'){
        this.$toast({
          message: res.info,
          duration: 2000,
        })
        localStorage.clear();
        this.luckyTimes = 0;
        this.$bus.emit('resetLogin');
      } else {
        this.luckyTimes = res.data.leftLotteryCount || 0;
        this.isShared = res.data.isShared;
      }
    });
    this.$bus.on('setLotteryCount', (LotteryCount) => {
      this.luckyTimes = LotteryCount;
    });
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.timer1);
    clearInterval(this.timer2);
    clearInterval(this.timer3);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Turntable.vue